import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';

import {EditSearchModal} from './edit-search.modal';

import type {SearchSettings} from 'src/openapi/admin/models/SearchSettings';

type Props = {
    onAdd: () => void,
    searchSettings: SearchSettings,
};

export const EditSearch = ({onAdd, searchSettings}: Props) => {
    const {shown, onClick, onClose} = useShown();

    return (
        <>
            <FlatButton onClick={onClick}><b>Edit Search</b></FlatButton>
            <Dialog shown={shown} setShown={onClose} wrapperProps={{style: {width: 600}}}>
                <EditSearchModal
                    searchSettings={searchSettings}
                    onClose={onClose}
                    onAdd={onAdd}
                />
            </Dialog>
        </>
    );
};
